import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="search01" uib-dropdown is-open="vm.isOpen" keyboard-nav>
            <input
                ng-keyup="$event.keyCode == 13 ? vm.redirectToSearchDetailPage() : null"
                ng-change="vm.search()"
                ng-model="vm.keyword"
                type="text"
                placeholder="{{ 'search.Find a worker or course...' | translate }}"
                id="searchkey"
            uib-dropdown-toggle>
            <button ng-click="vm.redirectToSearchDetailPage()">{{ 'search.Search' | translate }}</button>
            <ul class="ac01" uib-dropdown-menu role="menu" aria-labelledby="searchkey">
                <li class="heading" ng-if="vm.getIsNoResults()">{{ 'search.No results' | translate }}</li>
                <li class="heading" ng-if="!vm.keyword.length">{{ 'search.Type to search' | translate }}</li>
                <li class="heading" ng-if="vm.courses.length">{{ 'search.Courses' | translate }}</li>
                <li role="menuitem" ng-repeat="course in vm.courses">
                    <a ui-sref="authorized.courses.courses.edit.general({ id: course.id })">{{ course.name }}</a>
                </li>
                <li class="divider" ng-if="vm.PrivilegeService.canViewCourses() && vm.employees.length"></li>
                <li class="heading" ng-if="vm.employees.length">{{ 'search.Employees' | translate }}</li>
                <li role="menuitem" ng-repeat="employee in vm.employees">
                    <a ui-sref="authorized.user.employee.detail({ id: employee.id })">{{ employee.displayName }}</a>
                </li>
            </ul>
        </div>
`
})
export default class {
    constructor ($state, SearchResource, PrivilegeService) {
        this.$state = $state;
        this.SearchResource = SearchResource;
        this.PrivilegeService = PrivilegeService;
        this.keyword = '';
        this.courses = {};
        this.employees = {};
        this.searchCompleted = false;
        this.isOpen = false;
    }

    search () {
        this.isOpen = true;
        if (!this.keyword.length) {
            this.courses = {};
            this.employees = {};
            return;
        }
        this.searchRequest = this.SearchResource.getAutocompleteResults({ keyword: this.keyword }).$promise;
        this.searchRequest.then((results) => {
            this.courses = results.courses;
            this.employees = results.employees;
            this.searchCompleted = true;
        });
    }

    redirectToSearchDetailPage () {
        if (!this.keyword.length) {
            return;
        }
        this.isOpen = false;
        const keyword = this.keyword;
        this.searchRequest
            .catch(() => ({ courses: [], employees: [] }))
            .then((results) => this.$state.go(this.getSearchResultState(results), { keyword }));
    }

    /**
     * Opens the first tab that has results, so a search matching only employees does not land on an empty courses tab.
     */
    getSearchResultState (results) {
        const canViewCourses = this.PrivilegeService.canViewCourses();
        if (canViewCourses && results.courses.length) {
            return 'authorized.search.courses';
        }
        if (this.PrivilegeService.canViewUsers() && results.employees.length) {
            return 'authorized.search.employees';
        }
        return canViewCourses ? 'authorized.search.courses' : 'authorized.search.employees';
    }

    getIsNoResults () {
        return this.keyword.length && !this.courses.length && !this.employees.length && this.searchCompleted;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/header/private/search/index.js